import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { getPinnedPost, getSecondaryPinnedPost } from 'Redux/ducks/blog';
import 'Components/Blog/cards/BlogPostsCard.scss';

export default function BlogPinnedContainer({ type, blogCardNameTag }) {
  const [post, setPost] = useState({});

  const loadPost = async (getPost) => {
    const fetchedPost = await getPost();
    return setPost(fetchedPost);
  };

  useEffect(() => {
    if (type === 'primary') {
      loadPost(getPinnedPost);
    }

    if (type === 'secondary') {
      loadPost(getSecondaryPinnedPost);
    }
  }, [type]);

  if (isEmpty(post)) return false;

  const { title, introText, cover, uid } = post;

  const srcSet = [];

  const smallUrl = get(cover, '224x126.url');
  const smallWidth = get(cover, '224x126.dimensions.width');
  const mediumUrl = get(cover, '400x225.url');
  const mediumWidth = get(cover, '400x225.dimensions.width');
  const largeUrl = get(cover, '752x423.url');
  const largeWidth = get(cover, '752x423.dimensions.width');

  const originalWidth = get(cover, 'dimensions.width');

  if (originalWidth) {
    srcSet.push(`${cover.url} ${originalWidth}w`);
  }

  if (largeUrl && largeWidth) {
    srcSet.push(`${largeUrl} ${largeWidth}w`);
  }
  if (mediumUrl && mediumWidth) {
    srcSet.push(`${mediumUrl} ${mediumWidth}w`);
  }
  if (smallUrl && smallWidth) {
    srcSet.push(`${smallUrl} ${smallWidth}w`);
  }


  const TagName = blogCardNameTag;

  return (
    <article className="blog-post-card pinned-card">
      <Link to={`/blog/${uid}`} className="w-100" >
        <div className="blog-img-container responsive-image responsive-image--16by9">
          <img
            className="img-fluid img-full img-force-full blog-card-img"
            srcSet={srcSet.join(', ')}
            sizes="(min-width: 1520px) 872px, (min-width: 1200px) 740px, (min-width: 992px) 621px, (min-width: 768px) 704px, (min-width: 576px) 492px, 95vw"
            src={cover.url}
            alt={title}
            loading={type === 'primary' ? 'eager' : 'lazy'}
          />
        </div>
        <div className="p-3">
          <TagName className="blog-card-title">
            {title}
          </TagName>
          <p className="blog-card-intro-text">
            {introText && introText}
          </p>
        </div>
      </Link>
    </article>
  );
}

BlogPinnedContainer.propTypes = {
  type: PropTypes.string,
  blogCardNameTag: PropTypes.string,
};

BlogPinnedContainer.defaultProps = {
  type: 'primary',
  blogCardNameTag: 'h4',
};
